export class NewsPagination {
  private newsList: HTMLElement;
  private paginationContent: HTMLElement;
  private loadingAnimation: HTMLElement;
  private readonly loadMoreButton: HTMLButtonElement;
  private isLoading: boolean;

  constructor(newsList: HTMLElement) {
    this.newsList = newsList;
    this.isLoading = false;
    this.paginationContent = this.newsList.querySelector('[data-pagination-content]');
    this.loadMoreButton = this.newsList.querySelector('button');
    this.loadingAnimation = this.newsList.querySelector('.c-news-list__page-loader');

    if (this.loadMoreButton) {
      this.initLoadMore();
      this.initializeScrolling();
    }
  }

  initLoadMore() {
    this.loadMoreButton.addEventListener('click', () => {
      if (this.isLoading === false) {
        this.loadNextPage();
      }
    });
  }

  initializeScrolling() {
    window.addEventListener('scroll', () => {
      if (this.isLoading === false && this.paginationContent.getBoundingClientRect().bottom <= window.innerHeight) {
        this.loadNextPage();
      }
    })
  }

  loadNextPage() {
    let paginationUrl = this.getPaginationUrl();

    if (paginationUrl !== '') {
      this.showLoading();

      fetch(paginationUrl)
        .then(response => {
          return response.text();
        })
        .then(text => {
          this.hideLoading();
          let parser = new DOMParser();
          let doc = parser.parseFromString(text, 'text/html');

          let newPaginationContent: HTMLElement = doc.querySelector('[data-pagination-content]');
          let newsItems = newPaginationContent.innerHTML;

          this.paginationContent.innerHTML += newsItems;
          this.paginationContent.dataset.paginationUrl = newPaginationContent.dataset.paginationUrl;
          if (newPaginationContent.dataset.paginationUrl === '') {
            this.removeLoading();
          }
        })
        .catch(error => {
          this.hideLoading();
          console.error(error);
        });
    } else {
      this.removeLoading();
    }
  }

  showLoading() {
    this.isLoading = true;
    this.loadMoreButton.disabled = true;
    this.loadingAnimation.style.display = 'block';
  }

  hideLoading() {
    this.isLoading = false;
    this.loadMoreButton.disabled = false;
    this.loadingAnimation.style.display = 'none';
  }

  removeLoading() {
    this.isLoading = false;
    this.loadMoreButton.remove();
    this.loadingAnimation.remove();
  }

  getPaginationUrl() {
    let paginationContent: HTMLElement = this.newsList.querySelector('[data-pagination-content]');
    if (paginationContent) {
      return paginationContent.dataset.paginationUrl;
    }
  }

}

let paginationItems: NodeListOf<HTMLElement> = document.querySelectorAll('[data-pagination]');
paginationItems.forEach((item) => {
  new NewsPagination(item);
});
